import { gql } from '@apollo/client';

export default gql`
  query sessionInfos {
    sessionInfos {
      sessionInfosTotal
      sessionInfos {
        id
        ip
        userAgent
        browserName
        browserVersion
        platform
        os
        createdAt
        current
      }
    }
  }
`;
